// removed by extract-text-webpack-plugin
module.exports = {"container":"GnhYLzHfOsWkMQ2pXbYA_","title":"_1tLx-SYv21ukHdzYwEK3A6","button":"_1OTqDgWW4i2Z1BxvrIq4OX","icon1":"_2rDy0WMoe0xuu8ONLObkRT","icon2":"_2kH-st58CKp-jgxYaE921o","icon3":"_3JSvQGW6wonzIkyguexVfP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/Archived/styles.css
// module id = 3162
// module chunks = 0